<section id="simulation-table-section">
	<table
		id="simulation-table"
		datatable
		[dtOptions]="dtOptions"
		[dtTrigger]="dtTrigger"
		class="row-border hover"
	>
		<thead>
			<tr>
				<th>User</th>
				<th>Customer</th>
				<th>Region</th>
				<th>Project</th>
				<th>Simulation</th>
			</tr>
		</thead>
		<tbody>
			<tr
				class="dt-row"
				*ngFor="let sim of simulations"
				[class.selected-row]="sim === selectedSimulation"
				(click)="onRowClick(sim)"
			>
				<td>{{ sim.user.name }}</td>
				<td>{{ sim.customer.name }}</td>
				<td>{{ sim.region.name }}</td>
				<td>{{ sim.project.name }}</td>
				<td>{{ sim.name }}</td>
			</tr>
		</tbody>
	</table>
</section>